export const ADMIN_PATH = "/admin";
export const WORK_QUEUE_PATH = "/admin/work-queue";
export const TICKER_REQUESTS_PATH = "/admin/ticker-requests";
export const TICKER_REQUESTS_QUEUE_LINK = `${WORK_QUEUE_PATH}?category=request`;
export const INSTRUMENT_FIXES_PATH = "/admin/instrument-fixes";
export const INSTRUMENT_FIXES_QUEUE_LINK = `${WORK_QUEUE_PATH}?category=instrument`;
export const CORPORATE_ACTIONS_QUEUE_LINK = `${WORK_QUEUE_PATH}?category=corporate`;
export const DEFERRED_CORPORATE_ACTIONS_QUEUE_LINK = `${CORPORATE_ACTIONS_QUEUE_LINK}&status=deferred`;
export const SCHEDULERS_PATH = "/admin/schedulers";
export const JOBS_PATH = "/admin/jobs";
export const BLOCKED_JOBS_LINK = `${JOBS_PATH}?state=coverage_blocked`;
export const INSTRUMENTS_PATH = "/admin/instruments";
export const ACTIVITY_PATH = "/admin/activity";
export const INSTRUMENT_PARAM = "instrument";
export const instrumentLink = (instrumentId: number) =>
  `${INSTRUMENTS_PATH}?${INSTRUMENT_PARAM}=${instrumentId}`;
